import { useState, useEffect } from 'react';
import { postWithToken } from '../../utilities/fetchWithToken';
import { BASE_URL } from '../../utilities/BASE_URL';
import './SittingOutBox.css';

// Default removal window if the server hasn't sent a deadline yet (matches the backend's
// TurnTimerService.SIT_OUT_REMOVAL_MINUTES).
const FALLBACK_MS = 5 * 60 * 1000;

const fmt = (ms) => {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
};

// Centered overlay shown while the current user is unattended at the table (they toggled
// "Sit Out"/"Sit Away", left, disconnected, or their time bank expired) and offers a button to
// rejoin.
//
// noTimeLimit is set on a LIVE TOURNAMENT table, where tournament chips are table-instance
// currency and the only exit is busting: there is no removal timer at all, so rendering a
// countdown (least of all the 5:00 fallback) would be an outright lie. The seat keeps being
// dealt in and keeps posting blinds while away.
const SittingOutBox = ({ roomId, deadline, noTimeLimit }) => {
    const [remaining, setRemaining] = useState(
        deadline ? Math.max(0, deadline - Date.now()) : FALLBACK_MS
    );

    useEffect(() => {
        if (noTimeLimit) return;   // no removal clock exists on a tournament table
        if (!deadline) {
            setRemaining(FALLBACK_MS);
            return;
        }
        const tick = () => setRemaining(Math.max(0, deadline - Date.now()));
        tick();
        const id = setInterval(tick, 500);
        return () => clearInterval(id);
    }, [deadline, noTimeLimit]);

    const handleRejoin = async () => {
        try {
            await postWithToken(`${BASE_URL}/games/rejoin`, { roomId });
        } catch (e) {
            console.error('Rejoin failed', e);
        }
    };

    return (
        <div className="sitting-out-box">
            <span className="sitting-out-title">
                {noTimeLimit ? 'You are away' : 'You are sitting out'}
            </span>
            {!noTimeLimit && <span className="sitting-out-countdown">{fmt(remaining)}</span>}
            <span className="sitting-out-subtext">
                {noTimeLimit
                    ? 'Your seat, chips and blinds are still in play — you are auto check-folding'
                    : 'until you are removed from the table'}
            </span>
            <button className="sitting-out-rejoin-btn" onClick={handleRejoin}>
                Rejoin Table
            </button>
        </div>
    );
};

export default SittingOutBox;
